/* eslint-disable import/no-cycle */
import { put, takeEvery } from "redux-saga/effects";
import { getUsersAPI } from "../../apis/index";
import { loginUserAction } from "../slice/users";

export function* getUsersSaga({ payload }) {
  const users = yield getUsersAPI(payload);
  yield put(loginUserAction.fetchSuccess(users.data));
}

export function* logoutUserSaga() {
  yield put(loginUserAction.logoutUser());
}

export function* watchUsersAsync() {
  yield takeEvery(loginUserAction.getLoginUsersSlice, getUsersSaga);
  yield takeEvery(loginUserAction.logoutUsersSlice, logoutUserSaga);
}
